import { AnalyticsService } from '@moment/analytics/AnalyticsService';
import { getCurrentNumberOfInteractions } from '@moment/local-personalization/scorer.ts';

const VISIBILITY_FLASH_THRESHOLD_MS = 500;

export type StoryDismissalReason =
  | 'unmount'
  | 'story_changed'
  | 'background'
  | 'external_navigation';

export class StoryDismissalService {
  private analyticsService: AnalyticsService;
  private viewStartTime: number | null = null;
  private partner: string = '';
  private searchParams: URLSearchParams = new URLSearchParams();
  private contentId: string = '';
  private isTracking = false;

  constructor(analyticsService: AnalyticsService) {
    this.analyticsService = analyticsService;
  }

  public startTracking(
    partner: string,
    searchParams: URLSearchParams,
    contentId: string
  ) {
    if (this.isTracking) return;
    this.viewStartTime = Date.now();
    this.partner = partner;
    this.searchParams = searchParams;
    this.contentId = contentId;
    this.isTracking = true;
  }

  public isCurrentlyTracking() {
    return this.isTracking
  };

  public currentlyTrackedContentId() {
    return this.contentId;
  }

  public stopTracking(reason: StoryDismissalReason) {
    if (!this.isTracking || this.viewStartTime === null) {
      return;
    }

    const viewDuration = Date.now() - this.viewStartTime;

    if (viewDuration < VISIBILITY_FLASH_THRESHOLD_MS) {
      this.reset();
      return;
    }

    this.analyticsService.emitStoryDismissedEvent({
      numInteractions: getCurrentNumberOfInteractions(),
      partnerId: this.partner || 'unknown',
      searchParams: this.searchParams,
      duration: viewDuration,
      reason,
      contentId: this.contentId,
    });
    this.reset();
  }

  private reset() {
    this.viewStartTime = null;
    this.partner = '';
    this.searchParams = new URLSearchParams();
    this.isTracking = false;
    this.contentId = '';
  }
}
